import { apiSlice } from './apiSlice';

export interface PromptItem {
  id: number;
  prompt: string;
  category: string;
  PromptStatus: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PromptHistoryResponse {
  count: number;
  skip: number;
  take: number;
  data: PromptItem[];
}

export const promptApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPromptHistory: builder.query<
      PromptHistoryResponse,
      { category?: string; fromDate?: string; toDate?: string; skip?: number; take?: number }
    >({
      query: ({ category, fromDate, toDate, skip = 0, take = 7 }) => ({
        url: '/prompt',
        params: {
          ...(category && category !== 'all' && { category }),
          ...(fromDate && { fromDate }),
          ...(toDate && { toDate }),
          skip,
          take,
        },
      }),
      providesTags: ['Prompt'],
    }),

    updatePromptStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/prompt/${id}`, //
        method: 'PATCH',
        body: { status },
      }),
      invalidatesTags: ['Prompt'],
    }),

    deletePrompt: builder.mutation({
      query: (id) => ({
        url: `/prompt/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Prompt'],
    }),
    updatePrompt: builder.mutation({
      query: ({ id, prompt }) => ({
        url: `/prompt/${id}`,
        method: 'PATCH',
        body: { prompt },
      }),
      invalidatesTags: ['Prompt'],
    }),
  }),
});

export const {
  useGetPromptHistoryQuery,
  useUpdatePromptStatusMutation,
  useDeletePromptMutation,
  useUpdatePromptMutation,
} = promptApi;
